<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/TBOX3/TBOX3.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">3ʳᵈ Gen TBOX</div>
                <div class="detail-banner-desc">
                    Support C-V2X 3 scenes, supports Multi-Mode Multi-Fre(L1,L5/L2) GNSS, can reach Sub-Meter level accuracy position;<br />
                    Supports peak downlink speeds of 224 Mbps and uplink speeds of 120Mbps, integrates BLE6.0+UWB ,the position accuracy level up to 10 centimeters;<br />
                    Convenient service provided: 30 remote control  and 30+ data upload, offering user convenience while improving the operational efficiency of Original Equipment Manufacturers (OEMs);<br />
                    Safety Assurance: Equipped with emergency call (eCall) response and IBCall, providing comprehensive protection and information for occupants;<br />
                    Commitment to Innovation: The T-Box series reflects our unwavering pursuit of advanced connectivity, safety guarantees, and user-centric solutions, helping to realize smarter and safer mobility.

                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>
                    <div class="detail-desc">
                        <div>
                            Supports 4/5G and, Data Rate up to 226 M (DL)/ 120M(UL) bps.<br />
                        </div>
                        <div>
                            Supports 3GPP Rel-17 Redcap<br />
                        </div>
                        <div>
                            Integrated Multi-mode Multi-Frequency GNSS<br />
                        </div>
                        <div>
                            Ethernet communication, 100 Base-T1<br />
                        </div>
                        <div>
                            FOTA
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/TBOX3/TBOX3-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Dual core ARM Cortex-A55</div>
                                    <div class="k">CPU core</div>
                                </div>

                                <div class="spec-item">
                                    <div class="v">3.2K DMIPS</div>
                                    <div class="k">Computing Power</div>
                                </div>
                                <div class="spec-item spec-item-two">
                                    <div class="v">up to 700 MHz</div>
                                    <div class="k">CPU frequency</div>
                                </div>
                                
                                
                                <div class="spec-item">
                                    <div class="v">100 Base-T1</div>
                                    <div class="k">Ethernet</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Sub-M</div>
                                    <div class="k">Position Accuracy</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">14nm</div>
                                    <div class="k">Process</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Up to 226/ 120M bps</div>
                                    <div class="k">DL/UL Data rate</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">4Gb LPDDR4X+4Gb Nand Flash</div>
                                    <div class="k">Memory</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/TBOX3/TBOX3-1.jpg" alt="200-1-02">
                    </div>
                </div> -->

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '3ʳᵈ Gen TBOX - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/TBOX3.html'
};

import { createApp } from 'vue';
import App from './TBOX3.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./TBOX3.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
